
import { updateUser, uploadFile } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import { readCookie, dateFormatter } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    NavMenu
  }
})
export default class extends Vue {
  infoList: any = {} // 价格列表

  username: string = ''

  nickname: string = ''

  birthday: string = ''

  // 裁剪组件的基础配置option
  option: any = {
    img: 'https://qn-qn-kibey-static-cdn.app-echo.com/goodboy-weixin.PNG',
    size: 1,
    full: false,
    outputType: 'png',
    canMove: true,
    fixedBox: false,
    original: false,
    canMoveBox: true,
    autoCrop: true,
    // 只有自动截图开启 宽度高度才生效
    autoCropWidth: 150,
    autoCropHeight: 150,
    centerBox: false,
    high: true
  }

  show: boolean = true

  fixed: boolean = true

  fixedNumber: any[] = [1, 2]

  showDialog: boolean = false

  isCropper: boolean = false

  @Action('user/setUserInfoList') setUserInfoList!: Function

  @State('user') userinfor: any

  async created() {
    this.setUserInfoList();
    this.nickname = this.userinfor.userinfolist.nickName;

    this.birthday = dateFormatter(this.userinfor.userinfolist.birthday);
  }

  // 比较版本
  compareVersion(v1: any, v2: any) {
    v1 = v1.split('.');
    v2 = v2.split('.');
    const len = Math.max(v1.length, v2.length);

    // 调整两个版本号位数相同
    while (v1.length < len) {
      v1.push('0');
    }
    while (v2.length < len) {
      v2.push('0');
    }

    // 循环判断每位数的大小
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i]);
      const num2 = parseInt(v2[i]);

      if (num1 > num2) {
        return 1;
      } if (num1 < num2) {
        return -1;
      }
    }
    return 0;
  }

  //  修改个人信息
  async changeInfo() {
    if (dateFormatter(this.userinfor.userinfolist.birthday) === this.birthday) {
      const res: any = await updateUser({ nickName: this.nickname });
      if (res.data.code === 100) {
        await this.setUserInfoList();
        this.$message.success('修改成功!');
        const obj:any = {
          accessToken: readCookie('accessToken'),
          userName: this.userinfor.userinfolist.nickName,
          userId: this.userinfor.userinfolist.appUserExt.userId,
          userPhoto: this.userinfor.userinfolist.headImgUrl,
          macCode: '',
          phone: this.userinfor.userinfolist.phone,
          birthday: this.userinfor.userinfolist.birthday
        };
        const anchor = readCookie('anchor');
        if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
          delete obj.accessToken;
          obj.token = res.data.data;
          (this as any).webTransport.getUserLoginData(JSON.stringify(obj));
        } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
          delete obj.accessToken;
          obj.token = res.data.data;
          (window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
        } else {
          (window as any).JsIntrS.getUserLoginData(obj);
        }
      }
    } else {
      this.$confirm('保存生效后，生日不能再次修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res: any = await updateUser({ nickName: this.nickname, birthday: this.birthday });
        if (res.data.code === 100) {
          await this.setUserInfoList();
          this.$message.success('修改成功!');
          const obj:any = {
            accessToken: readCookie('accessToken'),
            userName: this.userinfor.userinfolist.nickName,
            userId: this.userinfor.userinfolist.appUserExt.userId,
            userPhoto: this.userinfor.userinfolist.headImgUrl,
            macCode: '',
            phone: this.userinfor.userinfolist.phone,
            birthday: this.userinfor.userinfolist.birthday
          };
          const anchor = readCookie('anchor');
          if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
            delete obj.accessToken;
            obj.token = res.data.data;
            (this as any).webTransport.getUserLoginData(JSON.stringify(obj));
          } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
            delete obj.accessToken;
            obj.token = res.data.data;
            (window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
          } else {
            (window as any).JsIntrS.getUserLoginData(obj);
          }
        }
      }).catch(() => {});
    }
  }

  // 上传头像
  private async getCropData() {
    this.showDialog = true;
  }

  // 图片裁剪
  private async uploadpic(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      let data;
      if (typeof e.target.result === 'object') {
        // 把Array Buffer转化为blob 如果是base64不需要
        data = window.URL.createObjectURL(new Blob([e.target.result]));
      } else {
        data = e.target.result;
      }
      this.option.img = data;
    };
    // 转化为base64
    // reader.readAsDataURL(file)
    // 转化为blob
    reader.readAsArrayBuffer(file);
    this.isCropper = true;
  }

  // 取消上传
  cancelCropper() {
    (this.$refs as any).clearFile.value = '';
    this.isCropper = false;
    this.showDialog = false;
  }

  // 上传图片
  private confirmPic() {
    (this.$refs as any).cropper.getCropBlob(async (data: any) => {
      const form = new FormData();
      form.append('fileData', data);
      form.append('type', '11');
      const res: any = await uploadFile(form);
      if (res.data.code === 100) {
        const headImage = res.data.data[0].sourceUrl;
        const response: any = await updateUser({
          headImage
        });
        if (response.data.code === 100) {
          this.showDialog = false;
          await this.setUserInfoList();
          const anchor = readCookie('anchor');
          const obj:any = {
            accessToken: readCookie('accessToken'),
            userName: this.userinfor.userinfolist.nickName,
            userId: this.userinfor.userinfolist.appUserExt.userId,
            userPhoto: this.userinfor.userinfolist.headImgUrl,
            macCode: '',
            phone: this.userinfor.userinfolist.phone,
            birthday: this.userinfor.userinfolist.birthday
          };
          if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
            delete obj.accessToken;
            obj.token = res.data.data;
            (this as any).webTransport.getUserLoginData(JSON.stringify(obj));
          } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
            delete obj.accessToken;
            obj.token = res.data.data;
            (window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
          } else {
            (window as any).JsIntrS.getUserLoginData(obj);
          }
          this.$message.success('更改头像成功！');
        } else {
          this.$message.error(res.data.message);
        }
      } else {
        this.$message.error(res.data.message);
      }
    });
  }

  reupload() {
    (this.$refs as any).clearFile.value = '';
    this.isCropper = false;
  }
}
